<template>
    <v-card color="#F5F2FB" flat class="rounded-0 pt-6">
        <v-container>
            <template v-if="details">
                <!-- ==================== 顶部信息条：名称 + 标签 + 价格 + 核心操作 ==================== -->
                <v-card flat class="detail-head template-panel">
                    <div class="head-main">
                        <h1 class="head-title">{{ details.name }}</h1>
                        <div class="head-tags" v-if="details.themes_tag_info && details.themes_tag_info.length">
                            <v-chip small class="head-chip" v-for="item in details.themes_tag_info"
                                :key="item.themes_tag_id">{{ item.name }}</v-chip>
                        </div>
                        <div class="head-meta">
                            <span>{{ $t('作者') }}：{{ details.nickname }}</span>
                            <span class="head-meta-sep">·</span>
                            <span>{{ $t('更新时间') }}：{{ details.updatetime }}</span>
                        </div>
                    </div>
                    <div class="head-side">
                        <div class="head-price">
                            <template v-if="details.type == 2">{{ details.symbol }}<b>{{ details.price }}</b></template>
                            <span class="head-free" v-else>{{ $t('免费') }}</span>
                        </div>
                        <div class="head-actions">
                            <a v-if="previewLink" :href="previewLink" target="_blank" rel="noopener">
                                <v-btn outlined rounded color="#7331FF">{{ $t('实时预览') }}
                                    <v-icon small class="ml-1">mdi-open-in-new</v-icon>
                                </v-btn>
                            </a>
                            <!-- 预览站没配置好时不再给一个点了就报错的链接 -->
                            <v-btn v-else outlined rounded color="#B0B7C3" @click="tipPreview">
                                {{ $t('实时预览') }}
                                <v-icon small class="ml-1">mdi-open-in-new</v-icon>
                            </v-btn>
                            <v-btn v-if="details.is_buy == 0" color="#7331FF" dark rounded @click="isPaid ? scrollToBuy() : tocreate()">
                                {{ $t('立即购买') }}
                            </v-btn>
                            <!-- 已购买后必须还能应用：以前这里是个置灰按钮，
                                 「应用到店铺」只在刚下单的弹窗里出现一次，关掉就再也进不去 -->
                            <v-btn v-else color="#7331FF" dark rounded @click="touse">
                                {{ $t('应用到当前店铺') }}
                            </v-btn>
                        </div>
                    </div>
                </v-card>

                <v-row class="mt-5">
                    <!-- ==================== 左：封面大图 + 描述/特点 ==================== -->
                    <v-col cols="12" lg="8">
                        <v-card flat class="template-panel pa-4 detail-cover">
                            <img :src="details.cover_img" alt="" class="cover-main">
                        </v-card>

                        <v-card flat class="template-panel pa-5 mt-5">
                            <p class="info-title">{{ $t('模板介绍') }}</p>
                            <p class="detail-desc">{{ details.des }}</p>
                            <v-divider class="my-4"></v-divider>
                            <p class="info-title">{{ $t('主题模板特点') }}</p>
                            <div class="feature-grid" v-if="details.features && details.features.length">
                                <div class="feature-item" v-for="(fitem, fidx) in details.features" :key="fidx">
                                    <v-icon color="#7331FF" size="18" class="mr-2">mdi-check-circle</v-icon>
                                    <span>{{ fitem }}</span>
                                </div>
                            </div>
                        </v-card>
                    </v-col>

                    <!-- ==================== 右：sticky 购买卡 + 规格 + 作者 ==================== -->
                    <v-col cols="12" lg="4">
                        <div class="sticky-side">
                            <!-- 购买卡 -->
                            <v-card flat class="template-panel pa-5 buy-card">
                                <div class="buy-head">
                                    <span class="buy-title">{{ $t('模版价格') }}</span>
                                    <span class="buy-price" v-if="details.type == 2">{{ details.symbol }}<b>{{ details.price }}</b></span>
                                    <v-chip v-else color="success" class="px-4">{{ $t('免费') }}</v-chip>
                                </div>
                                <v-divider class="my-3"></v-divider>
                                <div v-if="details.is_buy == 0">
                                    <div v-if="details.type == 2">
                                        <p class="pay-title">{{ $t('支付方式') }}</p>
                                        <div class="pay-list">
                                            <div v-for="(pitem, pidx) in paylist" :key="pidx" class="pay-item"
                                                :class="pay_type == pitem.pay_type ? 'checked-pay' : ''"
                                                @click="pay_type = pitem.pay_type">
                                                <img :src="pitem.logo" alt="alt" height="40">
                                            </div>
                                        </div>
                                    </div>
                                    <v-btn color="#7331FF" dark width="100%" large class="my-3 buy-btn" @click="tocreate">
                                        {{ $t('立即购买') }}
                                    </v-btn>
                                </div>
                                <v-btn v-else color="#7331FF" dark block large class="buy-btn my-2" @click="touse">
                                    {{ $t('应用到当前店铺') }}
                                </v-btn>
                                <div class="benefits">
                                    <div class="benefit">
                                        <v-icon color="success" small class="mr-2">mdi-check-circle-outline</v-icon>
                                        <span>{{ $t('未来更新') }}</span>
                                    </div>
                                    <div class="benefit">
                                        <v-icon color="success" small class="mr-2">mdi-check-circle-outline</v-icon>
                                        <span>{{ $t('提供6个月的支持') }}</span>
                                    </div>
                                    <div class="benefit">
                                        <v-icon color="success" small class="mr-2">mdi-check-circle-outline</v-icon>
                                        <span>{{ $t('由Taoify检查质量') }}</span>
                                    </div>
                                </div>
                            </v-card>

                            <!-- 规格 -->
                            <v-card flat class="template-panel pa-5 mt-5">
                                <p class="info-title">{{ $t('模板规格') }}</p>
                                <div class="spec-row">
                                    <span class="spec-key">{{ $t('高分辨率') }}</span>
                                    <span class="spec-val">{{ details.is_high_resolution == 1 ? $t('是的') : $t('不支持') }}</span>
                                </div>
                                <div class="spec-row">
                                    <span class="spec-key">{{ $t('可兼容浏览器') }}</span>
                                    <span class="spec-val">{{ details.support_browsers }}</span>
                                </div>
                                <div class="spec-row">
                                    <span class="spec-key">{{ $t('布局') }}</span>
                                    <span class="spec-val">{{ details.layout }}</span>
                                </div>
                                <div class="spec-row">
                                    <span class="spec-key">{{ $t('模版ID') }}</span>
                                    <!-- 店主发布的模板 themes_id 恒为 0，展示真正的编号 -->
                                    <span class="spec-val">{{ details.themes_number || details.themes_id }}</span>
                                </div>
                                <div class="spec-row">
                                    <span class="spec-key">{{ $t('发表时间') }}</span>
                                    <span class="spec-val">{{ details.createtime }}</span>
                                </div>
                            </v-card>

                            <!-- 作者 -->
                            <v-card flat class="template-panel pa-5 mt-5">
                                <p class="info-title">{{ $t('关于作者') }}</p>
                                <div class="author-box">
                                    <v-avatar size="52" v-if="!details.avatar">
                                        <img src="@/assets/images/template/demo.png" alt="alt">
                                    </v-avatar>
                                    <v-avatar size="52" v-else>
                                        <img :src="details.avatar" alt="alt">
                                    </v-avatar>
                                    <div class="pl-3">
                                        <p class="author-name mb-0">{{ details.nickname }}</p>
                                        <p class="author-count mb-0" v-if="details.other_themes">
                                            {{ details.other_themes.length }} {{ $t('个作品') }}
                                        </p>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <!-- ==================== 其他作品 ==================== -->
                <v-card flat class="template-panel pa-5 mt-5 mb-8"
                    v-if="details.other_themes && details.other_themes.length">
                    <p class="info-title">{{ $t('其他作品') }}</p>
                    <div class="other-grid">
                        <div class="other-theme-card" v-for="n in details.other_themes" :key="n.themes_id"
                            @click="go_detail(n.themes_id)">
                            <div class="other-theme-cover">
                                <img :src="n.cover_img" alt="" class="other-theme-img">
                            </div>
                            <p class="other-theme-name">{{ n.name }}</p>
                        </div>
                    </div>
                </v-card>
            </template>
        </v-container>
        <v-dialog v-model="usedShow" max-width="440">
            <v-card class="pa-0" style="border-radius:16px;overflow:hidden;">
                <div class="buy-success-head">
                    <div class="buy-success-icon">
                        <v-icon size="28" color="#fff">mdi-check</v-icon>
                    </div>
                    <p class="buy-success-title mb-0">{{ $t('购买成功') }}</p>
                    <p class="buy-success-sub mb-0">{{ $t('购买成功！请在模板中心查看使用。') }}</p>
                </div>
                <div class="buy-success-actions">
                    <v-btn text rounded small @click="usedShow = false">{{ $t('仅关闭') }}</v-btn>
                    <v-btn outlined rounded small @click="usedShow=false; $router.push('/user-index')">{{ $t('查看已购买模版') }}</v-btn>
                    <v-btn color="#7331FF" dark rounded small depressed @click="touse">{{ $t('应用到当前店铺') }}</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            details: null,
            themes_id: 0,
            // 市场上还有「店主发布的模板」，用 custom_themes_id 标识；
            // 两者互斥：官方 themes_id>0，自定义 custom_themes_id>0
            custom_themes_id: 0,
            source: 'official',
            pay_type: 1,//1=支付宝，2=paypal
            paylist: [],
            usedShow: false,//立即使用弹窗
        }
    },
    watch: {
        "$route.query.themes_id"(val) {
            this.getdetail();
        },
        "$route.query.custom_themes_id"(val) {
            this.getdetail();
        }
    },
    mounted() {
        this.getdetail();
    },
    computed: {
        // 付费模板：顶部按钮先滚到右侧支付卡选支付方式，而不是直接下单
        isPaid() {
            return this.details && Number(this.details.price || 0) > 0;
        },
        /**
         * 实时预览地址
         *
         * 后端给的是「店铺域名 + themes_id」，前台会按这套模板渲染装修内容。
         * 但历史数据里 dp_themes.link 存的是某个演示店铺的域名，演示店下线后
         * 会 302 到 /store_absent?store_absent=1 —— 就是点了「实时预览」看到的报错页。
         * 这种情况不给可点链接，改成提示，免得用户以为是模板坏了。
         */
        previewLink() {
            const link = this.details && this.details.link ? String(this.details.link) : '';
            if (!link || link.indexOf('store_absent') !== -1) return '';
            return link;
        }
    },
    methods: {
        getdetail() {
            this.themes_id = this.$route.query.themes_id || 0;
            this.custom_themes_id = this.$route.query.custom_themes_id || 0;
            this.source = this.custom_themes_id ? 'custom' : 'official';
            const param = this.custom_themes_id
                ? { custom_themes_id: this.custom_themes_id }
                : { themes_id: this.themes_id };
            this.$api.template.detail(param).then(res => {
                if (res.status) {
                    this.details = res.data;
                    if (res.data.source) {
                        this.source = res.data.source;
                    }
                    if (res.data.type == 2) {
                        this.getpaytype();
                    }
                }
            })
        },
        getpaytype() {
            this.$api.template.paytype().then(res => {
                if (res.status) {
                    this.paylist = res.data;
                }
            })
        },
        tocreate() {
            // 下单参数跟着模板来源走，混用会被后端当成「官方模板不存在」
            const param = this.source === 'custom'
                ? { custom_themes_id: this.custom_themes_id }
                : { themes_id: this.themes_id };
            this.$api.template.create(param).then(res => {
                if (res.status == 1) {
                    // 免费/付费一律按售价判定：dp_themes_custom.type 允许 3（自定义），
                    // 按 type==1 判会把 0 元模板也推去支付页
                    if (Number(this.details.price || 0) <= 0) {
                        this.$Toast({ content: this.$t('购买成功') });
                        this.usedShow = true;
                        this.getdetail();
                    } else {
                        this.topay(res.data);
                    }
                }
            })
        },
        touse() {
            // 官方模板：use_themes 直接把官方模板铺到本店
            // 店主发布的模板：买家店里没有对应行，要 apply_custom_themes 现场复制一份
            const req = this.source === 'custom'
                ? this.$api.template.apply_custom({ custom_themes_id: this.custom_themes_id })
                : this.$api.template.use_themes({ themes_id: this.themes_id });
            req.then(res => {
                this.usedShow = false;
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getdetail();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },
        topay(sn) {
            this.$api.template.payed({ order_sn: sn, pay_type: this.pay_type }).then(res => {
                if (res.status) {
                    window.open(res.data)
                }
            })
        },
        tipPreview() {
            this.$Toast({
                content: this.$t('预览站点暂时不可用，请稍后再试或联系平台'),
                type: 'error'
            });
        },
        go_detail(id) {
            this.$router.push({ path: '/template-detail', query: { themes_id: id } })
        },
        // 付费模板：顶部"立即购买"滚到右侧支付卡选择支付方式
        scrollToBuy() {
            const el = document.querySelector('.buy-card');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                this.tocreate();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.buy-success-head {
    text-align: center;
    padding: 24px 20px 16px;
    background: linear-gradient(180deg, #F0E9FF 0%, #fff 100%);
}
.buy-success-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #22C55E;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.25);
}
.buy-success-title {
    font-size: 16px;
    font-weight: 700;
    color: #1F2A3D;
    margin-bottom: 4px;
}
.buy-success-sub {
    font-size: 12px;
    color: #6B7689;
    line-height: 1.5;
}
.buy-success-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px 16px;
}

/* 白卡面板 */
.template-panel {
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.05);
}

/* ===================== 顶部信息条 ===================== */
.detail-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 28px 32px;
    flex-wrap: wrap;

    .head-title {
        font-size: 26px;
        font-weight: 700;
        color: #0F3460;
        margin-bottom: 10px;
    }

    .head-tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 12px;
    }

    .head-chip {
        background: rgba(115, 49, 255, 0.08) !important;
        color: #7331FF !important;
        font-weight: 600;
    }

    .head-meta {
        font-size: 13px;
        color: #8A96A8;

        .head-meta-sep {
            margin: 0 8px;
        }
    }

    .head-side {
        display: flex;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }

    .head-price {
        font-size: 16px;
        font-weight: 700;
        color: #7331FF;

        b {
            font-size: 26px;
        }

        .head-free {
            color: #09bb07;
            font-size: 20px;
        }
    }

    .head-actions {
        display: flex;
        gap: 12px;
    }
}

@media (max-width: 960px) {
    .detail-head {
        padding: 20px;

        .head-side {
            width: 100%;
            justify-content: space-between;
        }
    }
}

/* ===================== 封面大图 ===================== */
.detail-cover {
    background: #F8FAFC;
    border-radius: 14px;
    padding: 16px;
    border: 1px solid #F0F2F5;

    .cover-main {
        display: block;
        max-width: 100%;
        margin: 0 auto;
        border-radius: 8px;
    }
}

/* ===================== 信息区块 ===================== */
.info-title {
    font-size: 17px;
    font-weight: 700;
    color: #0F3460;
    margin-bottom: 14px;
}

.detail-desc {
    font-size: 14px;
    line-height: 1.8;
    color: #4A5568;
    margin-bottom: 0;
    /* 模板介绍可能是多语言多行（中/英/日/韩/阿），保留作者写的换行 */
    white-space: pre-line;
}

/* 特点网格 */
.feature-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
}

.feature-item {
    display: flex;
    align-items: center;
    background: #F7F4FF;
    border: 1px solid #EEE6FF;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: #3D4757;
}

/* ===================== 右侧 sticky ===================== */
.sticky-side {
    position: sticky;
    top: 24px;
}

/* 购买卡 */
.buy-card {
    .buy-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .buy-title {
        font-size: 15px;
        font-weight: 700;
        color: #242939;
    }

    .buy-price {
        font-size: 15px;
        font-weight: 700;
        color: #7331FF;

        b {
            font-size: 22px;
        }
    }

    .pay-title {
        font-size: 13px;
        font-weight: 600;
        color: #4A5568;
        margin: 4px 0 10px;
    }

    .pay-list {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .pay-item {
        border: 2px solid #EEF1F5;
        border-radius: 8px;
        padding: 6px 10px;
        cursor: pointer;
        background: #fff;
        transition: border-color 0.15s;

        &:hover {
            border-color: #C9B8F2;
        }

        &.checked-pay {
            border-color: #7331FF;
        }
    }

    .buy-btn {
        text-transform: none;
        font-weight: 700;
        border-radius: 10px;
    }

    .benefits {
        margin-top: 8px;
    }

    .benefit {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #4A5568;
        padding: 6px 0;
    }
}

/* 规格 */
.spec-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-bottom: 1px dashed #F0F2F5;

    &:last-child {
        border-bottom: none;
    }

    .spec-key {
        font-size: 13px;
        color: #8A96A8;
    }

    .spec-val {
        font-size: 13px;
        color: #242939;
        font-weight: 500;
        text-align: right;
    }
}

/* 作者 */
.author-box {
    display: flex;
    align-items: center;

    .author-name {
        font-size: 15px;
        font-weight: 700;
        color: #242939;
    }

    .author-count {
        font-size: 12px;
        color: #9AA5B5;
    }
}

/* ===================== 其他作品 ===================== */
.other-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 700px) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.other-theme-card {
    cursor: pointer;
    border: 1px solid #EEF1F5;
    border-radius: 12px;
    overflow: hidden;
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: 0 8px 20px rgba(15, 52, 96, 0.1);
    }
}

.other-theme-cover {
    position: relative;
    width: 100%;
    padding-top: 177.78%; /* 9:16 */
    overflow: hidden;
    background: #F8FAFC;
}

.other-theme-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.other-theme-name {
    font-size: 13px;
    color: #242939;
    padding: 8px 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0;
}
</style>
